(function($) {

    function findContainingRow($el, options) {
        return $el.is(options.rowSelector) ? $el : $el.closest(options.rowSelector);
    }

    function showBlock($block, options) {
        $block.find(':input').each(function() {
            var $el = $(this);

            if (options.disableOnHide) {
                var isDisabled = $el.data('isDisabled');
                $el.removeData('isDisabled');

                if (isDisabled !== undefined) {
                    $el.attr('disabled', isDisabled);
                }
            }

            if (options.removeRequiredOnHide) {
                var isRequired = $el.data('isRequired');
                $el.removeData('isRequired');

                if (isRequired !== undefined) {
                    $el[options.useHtml5 ? 'attr' : 'toggleClass']('required', isRequired);
                }
            }
        });

        $block.show();
    }

    function hideBlock($block, options) {
        $block.hide();

        $block.find(':input').each(function () {
            var $el = $(this);

            if (options.disableOnHide) {
                if ($el.data('isDisabled') === undefined) {
                    $el.data('isDisabled', $el.attr('disabled') || false);
                }

                $el.attr('disabled', true);
            }

            if (options.removeRequiredOnHide) {
                if ($el.data('isRequired') === undefined) {
                    $el.data('isRequired', $el[options.useHtml5 ? 'attr' : 'hasClass']('required') || false);
                }

                $el[options.useHtml5 ? 'attr' : 'toggleClass']('required', false);
            }
        });
    }

    function getSourceData($container, $source) {
        if (!$source.is(':input')) {
            $source = $source.find(':input')
        }

        if ($source.is('input[type=radio]')) {
            return $container.find('input[name="' + $source.attr('name') + '"]').serializeArray();

        } else if ($source.is('input[type=checkbox]')) {
            return [{
                name: $source.attr('name'),
                value: $source.is(':checked') ? '1' : ''
            }];

        } else {
            return $source.serializeArray();
        }
    }

    function calculateFieldVisibility($container, $target, options) {
        var allData = $target.data(),
            dataName, sourceName, $source, sourceData, displayWhen;

        for (dataName in allData) {
            if (!allData.hasOwnProperty(dataName)) {
                continue;
            }

            sourceName = dataName.match(/^blockToggle(\w+)$/);

            if (!sourceName) {
                continue;
            }

            sourceName = sourceName[1].toLowerCase();
            $source    = $container.find('[data-block-toggle="' + sourceName + '"]');

            if (!$source.is('input[type=hidden]') && findContainingRow($source, options).css('display') === 'none') {
                continue;
            }

            displayWhen = $target.data('block-toggle-' + sourceName);
            sourceData  = getSourceData($container, $source);

            // intersect [toggle values] with [target data]
            // show when at least one value is contained in both sets
            for (var i = 0, dl = sourceData.length; i < dl; ++i) {
                if (displayWhen.indexOf(sourceData[i].value) !== -1) {
                    return true;
                }
            }
        }

        return false;
    }

    function onSourceChange($container, name, options) {
        $container.find('[data-block-toggle-' + name + ']').each(function () {
            var $target = $(this),
                display = calculateFieldVisibility($container, $target, options),
                $block  = findContainingRow($target, options);

            if (display) {
                showBlock($block, options);
            } else {
                hideBlock($block, options);
            }
        });
    }

    $.fn.dataBlockToggle = function (options) {
        options = $.extend({}, $.fn.dataBlockToggle.defaults, options);

        return this.each(function() {
            var $container = $(this);

            $container.find('[data-block-toggle]').each(function () {
                var $toggle = $(this),
                    $input  = $toggle.is(':input') ? $toggle : $toggle.find(':input'),
                    name    = $toggle.data('block-toggle').toLowerCase();

                // save lower-cased name
                $toggle.attr('data-block-toggle', name);

                var onToggle = function() {
                    onSourceChange($container, name, options);
                };

                $input.on('change', onToggle);
                findContainingRow($input, options).on('show hide', onToggle);
                $input.trigger('change');
            });
        });
    };

    $.fn.dataBlockToggle.defaults = {
        rowSelector:   'fieldset, section, div.row',
        useHtml5:      true,
        disableOnHide: true,
        removeRequiredOnHide: true
    };

})(jQuery);



// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/jquery.dataBlockToggle.js